"use strict";
const { v4: uuid } = require('uuid');
const { VARIABLE } = require('../operandTypes');
exports.generateVariable = ({ variableId = uuid(), stepId }) => ({
    type: VARIABLE,
    variableId,
    stepId,
});
//# sourceMappingURL=variableFactory.js.map